import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { guestJoin } from '../../../../api/globalAPI';
import { TYPE, URL } from '../../../../constant';
import { useAlert, useInput, useLoading, useUserInfo } from '../../../../hooks';
import { emailMasking, emailRegExp } from '../../../../utils/utilityEtc';
import Popup from '../../../common/Popup';
import PopupTrigger from '../../../common/PopupTrigger';

import EmailInput from './EmailInput';
import PasswordInput from './PasswordInput';
import NameInput from './NameInput';
import Agreed from './Agreed';

function JoinV2(props) {
  const history = useHistory();

  const { t } = useTranslation();

  const [Alert, CodeAlert] = useAlert();
  const { info } = useUserInfo();
  const { setLoading, clearLoading } = useLoading();

  const [email, onChangeEmail, onResetEmail] = useInput('');
  const [password, onChangePassword, onResetPassword] = useInput('');
  const [name, onChangeName] = useInput('');
  const [agreeds, onChangeAgreeds] = useState({
    terms: false,
    privacy: false,
    marketing: false
  });

  const [modalFlag, setModalFlag] = useState(false);

  const onSubmit = useCallback(async () => {
    if (info?.memberType === TYPE.GB_USER_TYPE.MEMBER) {
      setModalFlag(true);
    } else {
      joinAPICall()
    }
  }, [email, password, name, info, agreeds]);

  const joinAPICall = useCallback(async () => {

    let msg = '';

    if (!email || !emailRegExp(email)) msg = t("MY_05_02.msg006");
    else if (!password) msg = t("front_message.msg034");
    else if (password.length < 6) msg = t("MY_02_05.msg020", { c: 6 });
    else if (!name) msg = t("MY_02_05.msg034");
    else if (!agreeds.terms || !agreeds.privacy) msg = t("MY_02_01.msg010");

    if (msg) {
      Alert(msg);
      return;
    };

    const params = {
      sbsceMbrId: info?.userId,
      mbrId: info?.learnerId,
      emailAdrs: email,
      mbrNm: name,
      pw: password,
      chnCd: TYPE.CHANNEL.GLOBAL01,
      langCd: 'KO',
      item1: agreeds.terms ? 'Y' : 'N',
      item2: agreeds.privacy ? 'Y' : 'N',
      item3: 'Y',
      item4: agreeds.marketing ? 'Y' : 'N',
    }

    setLoading({ isShowSpinner: true, spinnerType: '1' });
    
    const resp = await guestJoin(params);
    let isMaketing = params.item4 ? 'Y' : 'N';

    if (resp.code !== 'S000000') {
      clearLoading();
      if (resp?.code) {
        CodeAlert(resp)
      } else {
        Alert(t("MY_02_05.msg028"));
      }
      return;
    }

    localStorage.setItem('access.email', email);
    clearLoading();

    history.push({
      pathname: URL.ACCOUNT.JOIN.SUCCESS,
      state: {
        email,
        password,
        isMaketing,
        brthmt: info?.learnerBirth,
        mbrNm: name,
      },
    });
  }, [email, password, name, info, agreeds]);

  const memberChangeAlert = (params) => {
    return (
      <PopupTrigger
        onClose={() => {
          setModalFlag(false);
        }}
      >
        <Popup buttonLabel={["확인", "취소"]} onConfirm={(e) => joinAPICall(params)}>
          <p 
            className="lc-alert_txt m-fw-normal"
            dangerouslySetInnerHTML={{ __html: t("MY_02_05.msg035", { e: emailMasking(info?.userEmail) })}}
          />
        </Popup>
      </PopupTrigger>
    );
  };

  return (
    <React.Fragment>
      <div className="header_top gb bg_sky" >
        <div className="inner">
          <div className="btns_wrap cls">
            <div className="app_btn">
              <button
                className="btn_exit"
                type="button"
                onClick={() => history.goBack()}
              >
                <img src="./static/images/icon/btn_back.svg" alt="" />
              </button>
            </div>
            <div className="tit_gm center_tit24">{t("MY_02_05.msg001")}</div>
          </div>
        </div>
      </div >
      <div className="layout-def layout-sl bg_gray gb member_step1">
        <div className="container">
          <div className="inner">
            <div className="wirte_form w672">
              <section>
                <h2>{t("MY_02_05.msg036")}</h2>
                <div className="input_cont">
                  <EmailInput
                    email={email}
                    onChangeEmail={onChangeEmail}
                    onResetEmail={onResetEmail}
                  />
                </div>
                <div className="input_cont">
                  <PasswordInput
                    password={password}
                    onChangePassword={onChangePassword}
                    onResetPassword={onResetPassword}
                  />
                </div>

                <div className="input_cont">
                  <NameInput 
                    name={name}
                    onChangeName={onChangeName}
                  />
                </div>
                <div className="lower_area">
                  <Agreed 
                    agreeds={agreeds}
                    onChangeAgreeds={onChangeAgreeds}
                  />
                </div>
              </section>
              <div className="bottom_btn_wrap cls">
                <button
                  type="button"
                  className="btn btn-blue"
                  onClick={onSubmit}
                >
                  {t("MY_02_05.msg016")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalFlag && memberChangeAlert()}
    </React.Fragment>
  );
}

export default JoinV2;